import styled, { css } from 'styled-components'
import { body_large } from '../../theme/type-styles'
import { gray_6 } from '../../theme/colors';
import { spacing_2, spacing_3 } from '../../theme/spacing';
import { xsMd } from '../../theme/utils/media-query';

export function makeSubheader (element) {
  return styled(element)`
    ${body_large};
    color: ${ gray_6 };
    margin-bottom: ${ props => props.marginBottom || spacing_3 };
    ${props => props.textAlign && css`
      text-align: ${props.textAlign};
    `}

    strong {
      font-weight: bold;
    }

    ${props => props.width && css`
      width: ${props.width};
    `}

    ${xsMd(css`
      margin-bottom: ${ props => props.marginBottom ||  spacing_2 };
    `)}
  `
}

export default makeSubheader